import React, { PropTypes } from 'react';
import shallowEqual from 'recompose/shallowEqual';
import $ from 'jquery';
import cx from 'classnames';
import AsyncImage from './AsyncImage';
import { defaultThumbnail } from 'utils/assets';

// TODO: correct controlled input runtime warning
export default class ResourceCard extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    resource: PropTypes.object,
    raw: PropTypes.object,
    onChange: PropTypes.func,
    canUpdate: PropTypes.bool,
    onDelete: PropTypes.func,
    canDelete: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.element,
  };

  static defaultProps = {
    className: '',
    canUpdate: true,
    canDelete: true,
  };

  constructor(props) {
    super(props);
    let value, mini, thumbnail;
    if (props.resource) {
      value = props.resource.id;
      mini = props.resource.mini;
      thumbnail = props.resource.web;
    }

    this.state = {
      value,
      mini,
      thumbnail,
    };

    this.displaySelector = this.displaySelector.bind(this);
    this.fileSelected = this.fileSelected.bind(this);
    this.removeResource = this.removeResource.bind(this);
  }

  shoudComponentUpdate(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }

  componentDidMount() {
    $(this.refs.dimmer).dimmer({
      on: 'hover',
    });

    const { raw } = this.props;
    if (raw) {
      // Forcing thumbnail generation
      this.generateThumbnail(raw);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resource) {
      this.setState({
        value: nextProps.resource.id,
        mini: nextProps.resource.mini,
        thumbnail: nextProps.resource.web,
      });
    }
  }

  displaySelector() {
    $(this.refs.file).trigger('click');
  }

  getResource() {
    return this.state.file;
  }

  getValue() {
    return this.state.value;
  }

  getThumbnailUrl() {
    if (this.state.thumbnail && this.state.thumbnail.trim().length) {
      return this.state.thumbnail;
    }

    return defaultThumbnail();
  }

  fileSelected(evt) {
    const file = evt.target.files[0];

    if (file) {
      // Updating thumbnail
      this.generateThumbnail(file);
    }
  }

  generateThumbnail(file) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.setState({
          file,
          thumbnail: reader.result,
        });

        if (this.props.onChange) {
          this.props.onChange(file);
        }
      },
      false
    );

    reader.readAsDataURL(file);
  }

  removeResource() {
    this.setState({
      thumbnail: undefined,
      file: undefined,
      value: '',
    });

    if (this.props.onDelete) {
      this.props.onDelete();
    }
  }

  render() {
    const {
      name,
      className,
      title,
      children,
      canDelete,
      canUpdate,
    } = this.props;
    const { value } = this.state;

    const renderImage = () => {
      if (canUpdate || canDelete) {
        return (
          <div className="blurring dimmable image" ref="dimmer">
            <div className="ui dimmer">
              <div className="content">
                <div className="center">
                  <div className="ui vertical buttons">
                    {canUpdate && (
                      <div
                        className="ui inverted small update button"
                        onClick={this.displaySelector}
                      >
                        Modifier
                      </div>
                    )}
                    {!!this.state.thumbnail &&
                      canDelete && (
                        <div
                          className="ui inverted small delete red button"
                          onClick={this.removeResource}
                        >
                          Supprimer
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <AsyncImage src={this.getThumbnailUrl()} />
          </div>
        );
      } else {
        return (
          <div className="image">
            <AsyncImage src={this.getThumbnailUrl()} />
          </div>
        );
      }
    };

    return (
      <div className={cx('ui card', className)}>
        <input
          type="file"
          name={name}
          ref="file"
          style={{ display: 'none' }}
          accept="image/*"
          onChange={this.fileSelected}
        />
        <input type="hidden" name={`${name}_id`} defaultValue={value} />
        {renderImage()}
        {title && <div className="content">{title}</div>}
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/ResourceCard.js